module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/05-24ae6a7cf661d97e7bf467d8aac6adf4.jpg";